import React, { useEffect, useState } from "react";
import api from "../lib/api";

/** Render an uploaded news image through the authenticated admin endpoint. */
export default function PrivateNewsImage({ newsId, clubId, refreshVersion = 0, className = "", alt = "" }) {
    const [objectUrl, setObjectUrl] = useState("");

    useEffect(() => {
        if (!newsId || !clubId) {
            setObjectUrl("");
            return undefined;
        }
        let active = true;
        let createdUrl = "";
        api.get(`/comms/news/${newsId}/image`, {
            params: { club_id: clubId },
            responseType: "blob",
        }).then((response) => {
            if (!active) return;
            createdUrl = URL.createObjectURL(response.data);
            setObjectUrl(createdUrl);
        }).catch(() => {
            if (active) setObjectUrl("");
        });
        return () => {
            active = false;
            if (createdUrl) URL.revokeObjectURL(createdUrl);
        };
    }, [clubId, newsId, refreshVersion]);

    if (!objectUrl) return null;
    return <img src={objectUrl} alt={alt} className={className} />;
}
